module.exports = {
	"next": "next",
	"skip": "Jump to the Cozy creation",
	"cancel": "annulla",
	"back": "indietro",
	"sign up": "registra",
	"add email": "aggiungi account email",
	"welcome": "let me in!",
	"confirm": "conferma",
	"user missing properties": "Sorry but this user doesnt exist.",
	"step welcome user": "Benvenuto %{name}!",
	"step welcome anon": "Benvenuto!",
	"step welcome logout": "You're not %{name}?",
	"step welcome congrats": "Congratulation, thanks to you, your personal data are in a safe place, in your Cozy.",
	"step welcome next": "Next",
	"step agreement title": "Terms of Service",
	"step agreement subtitle": "In order to access your Cozy, you have to read and agree to our terms of service. As any human being, we guess you won't. Here is a short version of these we made just for you:",
	"step agreement element 0": "Take control and responsibility of your data, at home!",
	"step agreement element 1": "We take care of you and your cozy...",
	"step agreement element 2": "...unless you do something wrong with Cozy or your data",
	"step agreement element 3": "Choose which services use your data and understand their goal",
	"step agreement element 4": "Nobody (even us) can access your data in your Cozy",
	"step agreement element 5": "We have a few details about you, for legal reasons or service quality only",
	"step agreement stats": "I allow Cozy to collect data anonymously",
	"step agreement description 1": "You can access the full terms of service",
	"step agreement description 2": "By clicking on the button \"accept\", you acknowledge that you have read, understood, and agree to be bound by these terms.",
	"step agreement description link": "qui.",
	"step agreement next": "Accetta",
	"step preset": "impostazioni",
	"step import": "import your datas",
	"step email settings": "configura la tua email",
	"preset email": "e-mail",
	"preset email tip": "It will be used to contact you if you lose your password.",
	"preset name": "nome",
	"step password empty": "Password's value is missing.",
	"step password too weak": "Your password is too weak. You should add an uppercase, a number, a special character or a longer password.",
	"step password title": "Secure your password",
	"step password label": "password",
	"step password input placeholder": "es. \"dEj875ghj9273;eR\"",
	"step password submit": "conferma",
	"step password show": "Mostra password",
	"step password hide": "Nascondi password",
	"step password description": "Your password has to be as complicated as possible. It will prevent malicious people to access your own cloud. Using an uppercase, a number and a special character is mandatory.",
	"step password server error": "Something went wrong. Your password has not been saved.",
	"step infos title": "Complete your Cozy",
	"step infos description": "Some information are necessary to set up your Cozy.",
	"step infos public_name label": "Username",
	"step infos public_name placeholder": "The public display name your Cozy will use to speak with you.",
	"step infos email label": "Email",
	"step infos email placeholder": "Used by your Cozy to reset your password.",
	"step infos timezone label": "Timezone",
	"step infos timezone placeholder": "Your timezone helps to properly display your calendar.",
	"step infos submit": "Conferma",
	"step infos fetch data error": "Unable to fetch data from server.",
	"missing public_name": "You need to fill your username.",
	"missing email": "You need to fill your email.",
	"invalid email format": "Your email address doesn't seem correct.",
	"missing timezone": "You need to choose a timezone",
	"invalid timezone": "Your timezone doesn't seem correct.",
	"step accounts title": "Your Cozy has been successfully created!",
	"step accounts description line 1": "Now, we will accompagny you to connect your Cozy to your services.",
	"step accounts description line 2": "In the end, Cozy's goal is to help you reclaim your data!",
	"step accounts next": "Browse",
	"myaccounts info": "You can now access your Cozy at anytime by clicking 'Continue'",
	"myaccounts next": "Continua",
	"step confirmation title": "Welcome to your personal cloud!",
	"step confirmation description line 1": "Your Cozy is now ready.",
	"step confirmation description line 2": "You can get back your data from many services, and install the applications you want from our store.",
	"step confirmation next": "Enter",
	"step server error": "An error occurred while saving your progression. Reloading the page should fix the problem.",
	"preset name tip": "It's displayed when you share files with people or invite them to events.",
	"preset password": "password",
	"preset password tip": "A strong password of at least 8 characters is required (special characters recommended).",
	"preset timezone": "timezone",
	"preset timezone tip": "Your timezone is needed to properly display your calendar events.",
	"preset opt-in help": "Allow Cozy to use my usage stats to improve the product.",
	"preset opt-out newsletter": "Subscribe to the Beta Cozy Newsletter (highly recommended).",
	"import from google": "import my data from my Google account",
	"import google account": "Synchronize your Gmail account & import calendar, contacts and photos from Google",
	"import google account tip": "You'll need to sign in to your Google account to allow your Cozy to access to data hosted on Google",
	"leave google title": "Feed your data into Cozy",
	"leave google help me": "I don't understand what I have to do, please help me!",
	"leave google sign in content": "Sign in to your Google account and authorize your Cozy to access it. You will get a complex string. Copy it in your clipboard.",
	"leave google sign in": "Sign in to Google",
	"leave google code content": "Then, copy and paste the code from the popup in this field:",
	"leave google code": "google code",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Choose what you want to do with your data stored on Google servers:",
	"leave google choice sync gmail": "GMail - Access your email from Cozy",
	"leave google choice contacts": "One-time import of Google Contacts",
	"leave google choice calendar": "One-time import of Google Calendar",
	"leave google choice photos": "One-time import of Google Photos",
	"leave google confirm": "Import data",
	"import error": "An error occurs when trying to import your datas. Please try again later from the dedicated app.",
	"login welcome user": "Benvenuto %{username}",
	"login welcome anon": "Benvenuto",
	"login enter your password": "Enter your password to access your Cozy",
	"login password": "password",
	"login otp": "Authentication code",
	"login submit": "Accedi",
	"login auth success": "Authentication successful, let's go in!",
	"login recover": "Forgotten password? Send me an email to change it.",
	"login recover busy": "Sending an email containing instructions",
	"login recover sent title": "Email inviata",
	"login recover sent message": "Please check your email, follow instructions to reset your password",
	"login recover error title": "Errore nell'invio della mail",
	"login recover error message": "Error sending password recovery message, please check your MTA is running or contact server admin",
	"login wrong password title": "Credenziali errate",
	"login wrong password message": "The credentials you entered are incorrect. Please try again.",
	"login server error": "An error occured, please try again.",
	"reset password request success title": "Email inviata",
	"reset password request success message": "Check your emails, and follow the instructions to change your password.",
	"reset password request error": "An error occurred, the email has not been sent. Please try again. If the error persists, contact us at contact@cozycloud.cc.",
	"reset welcome user": "Change your password",
	"reset enter your password": "%{username}, set a new password to recover access to your Cozy.",
	"reset password": "password",
	"reset submit": "reset your password",
	"reset auth success": "password successfully resetted",
	"reset wrong password title": "Your password can't be resetted",
	"reset wrong password message": "The pasword you entered is incorrect, or your reset token is expired",
	"reset password error invalid key": "Your password request has expired. Please request a new one.",
	"reset password error password too weak": "Your password is too weak. You should add an uppercase, a number, a special character or a longer password.",
	"setup title": "We're setting up your Cozy…",
	"setup message": "You are now close to have your own personal cloud where your data are stored.",
	"setup on mobile title": "Synchronize your data with your Android device!",
	"setup on mobile message": "Check out our mobile app on Google Play:",
	"welcome title": "Congratulations on taking back control of your personal data!",
	"welcome message": "You can now store your data on your own personal cloud. As opposed to most cloud services, there is no data-mining taking place on your Cozy."
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/it.json
// module id = 42
// module chunks = 0